import React, { createContext, useContext, useState, useEffect } from 'react';

// Theme definitions
export const themes = {
  default: {
    name: 'Cosmic Eternity',
    id: 'default',
    colors: {
      primary: '#00d4ff',
      secondary: '#ff6b9d',
      accent: '#a855f7',
      quaternary: '#ffeb3b',
      bg: '#02010a',
      text: '#ffffff',
      'text-ethereal': '#e0e7ff',
      'text-muted': '#94a3b8'
    },
    fonts: {
      display: "'Orbitron', 'Rajdhani', sans-serif",
      body: "'Inter', 'Roboto', sans-serif"
    },
    background: 'cosmic',
    elements: 'cosmic-portals',
    animations: 'cosmic-float'
  }
};

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const [currentTheme] = useState(themes.default); // Always use default theme
  const [isTransitioning] = useState(false);

  // Apply theme to CSS custom properties
  useEffect(() => {
    const root = document.documentElement;
    
    // Apply color variables
    Object.entries(currentTheme.colors).forEach(([key, value]) => {
      root.style.setProperty(`--color-${key}`, value);
    });

    // Apply font variables
    Object.entries(currentTheme.fonts).forEach(([key, value]) => {
      root.style.setProperty(`--font-${key}`, value);
    });

    // Apply theme class
    root.className = root.className.replace(/theme-\w+/g, '');
    root.classList.add(`theme-${currentTheme.id}`);
  }, [currentTheme]);

  const value = {
    currentTheme,
    isTransitioning,
    themes
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};
